'use es6';

import PropTypes from 'prop-types';
import WidgetEditorWrapper from 'InpageEditorUI/components/WidgetEditorWrapper';
import { LameNullErrorHandlerInIframe } from 'ContentEditorUI/components/lameErrorHandling';
import InpageContext from 'InpageEditorUI/context/InpageContext';
import { getWidgetElement } from 'InpageEditorUI/lib/inpage/utils';

// Helper since there are multiple places WidgetEditorWrappers are being created
import { jsx as _jsx } from "react/jsx-runtime";
const WidgetWrapperContainer = ({
  widget,
  gates,
  bus,
  currentInpageMode,
  selectedItemId,
  isAnythingSelected = false,
  renderLanguage,
  hasUndoRedoAccess = false,
  highlightedWidgetId,
  sidebarIsExpanded,
  tellParentToHideModuleMenu,
  layoutSectionHoverPositionsClearedAndFrozen,
  layoutSectionHoverPositionsThawed,
  shouldShowFakeWidgetEditors,
  updateNodePositions,
  scopes,
  userId
}) => {
  const {
    $widget
  } = getWidgetElement(widget);
  if (!$widget || $widget.length === 0) {
    return null;
  }
  let componentKey;

  // Make sure the component key is refreshed when a module is moved between flex columns / dnd areas, this will force
  // widget editor instances down stream to always be up to date with module meta data from redux
  if (widget.containerId) {
    // Module in flex column
    componentKey = `${widget.name}-${widget.containerId}`;
  } else if (widget.layout_section_id) {
    // Module in a DnD area
    componentKey = `${widget.name}-${widget.layout_section_id}`;
  } else {
    // Static module
    componentKey = widget.name;
  }
  return /*#__PURE__*/_jsx(LameNullErrorHandlerInIframe, {
    children: /*#__PURE__*/_jsx(InpageContext.Consumer, {
      children: ({
        tinyMceGlobals,
        pickerComponentsWithState
      }) => /*#__PURE__*/_jsx(WidgetEditorWrapper, {
        widget: widget,
        tinyMceGlobals: tinyMceGlobals,
        pickerComponentsWithState: pickerComponentsWithState,
        bus: bus,
        gates: gates,
        selectedItemId: selectedItemId,
        highlightedWidgetId: highlightedWidgetId,
        isAnythingSelected: isAnythingSelected,
        currentInpageMode: currentInpageMode,
        sidebarIsExpanded: sidebarIsExpanded,
        renderLanguage: renderLanguage,
        hasUndoRedoAccess: hasUndoRedoAccess,
        tellParentToHideModuleMenu: tellParentToHideModuleMenu,
        updateNodePositions: updateNodePositions,
        layoutSectionHoverPositionsClearedAndFrozen: layoutSectionHoverPositionsClearedAndFrozen,
        layoutSectionHoverPositionsThawed: layoutSectionHoverPositionsThawed,
        shouldShowFakeWidgetEditors: shouldShowFakeWidgetEditors,
        scopes: scopes,
        userId: userId
      }, componentKey)
    })
  }, widget.id);
};
WidgetWrapperContainer.propTypes = {
  // Needed for WidgetEditorWrapper
  widget: PropTypes.object.isRequired,
  gates: PropTypes.array.isRequired,
  bus: PropTypes.object.isRequired,
  highlightedWidgetId: PropTypes.string,
  isAnythingSelected: PropTypes.bool.isRequired,
  selectedItemId: PropTypes.string,
  currentInpageMode: PropTypes.string.isRequired,
  sidebarIsExpanded: PropTypes.bool.isRequired,
  renderLanguage: PropTypes.string.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  tellParentToHideModuleMenu: PropTypes.func.isRequired,
  layoutSectionHoverPositionsClearedAndFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired,
  shouldShowFakeWidgetEditors: PropTypes.func.isRequired,
  updateNodePositions: PropTypes.func.isRequired,
  scopes: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired
};
export default WidgetWrapperContainer;